// extracted by mini-css-extract-plugin
module.exports = {"Container":"SectionsFilter_Container__3fT9h","Wrapper":"SectionsFilter_Wrapper__mZeDy"};